import React, { useEffect, useState } from "react";

const TABS = [
  { id: "Highlights", label: "Highlights" },
  { id: "Itinerary", label: "Itinerary" },
  { id: "Inclusions", label: "Inclusions" },
  { id: "Faq", label: "Faq" },
];

const Tab = () => {
  // ✅ Default active is Itinerary
  const [active, setActive] = useState("Itinerary");
  const [isScrolled, setIsScrolled] = useState(false);
  const [visibleTabs, setVisibleTabs] = useState([]);

  // ✅ Detect available sections & set default active tab
  useEffect(() => {
    const checkSections = () => {
      const foundTabs = TABS.filter(tab =>
        document.getElementById(tab.id)
      );

      setVisibleTabs(foundTabs);

      if (!foundTabs.length) return;

      // ✅ Prefer Itinerary, else first available tab
      const defaultTab =
        foundTabs.find(tab => tab.id === "Itinerary") || foundTabs[0];

      if (!foundTabs.find(tab => tab.id === active)) {
        setActive(defaultTab.id);
      }
    };

    checkSections();

    window.addEventListener("load", checkSections);
    window.addEventListener("resize", checkSections);

    return () => {
      window.removeEventListener("load", checkSections);
      window.removeEventListener("resize", checkSections);
    };
  }, [active]);

  // ✅ Add class after scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 1050);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Smooth scroll on click
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    setActive(id);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // ✅ Hide tabs if nothing exists
  if (!visibleTabs.length) return null;

  return (
    <div className={`tabs ${isScrolled ? "scrolled" : ""}`}>
      {visibleTabs.map(tab => (
        <button
          key={tab.id}
          className={active === tab.id ? "active" : ""}
          onClick={() => scrollToSection(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tab;